import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getMyServicemenProfile,
  updateServicemen,
  clearServicemenMessages,
} from "../redux/slices/servicemenSlice";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import ServicemenReviews from "./ServicemenReviews";

const ServicemenProfile = () => {

  const { userId } = useParams();
  const dispatch = useDispatch();
  const { myProfile, loading, successMessage, errorMessage } = useSelector(
    (state) => state.servicemen
  );

  const [editMode, setEditMode] = useState(false);
  const [form, setForm] = useState({
    fullName: "",
    phone: "",
    serviceName: "",
    experience: "",
    address: "",
  });

  useEffect(() => {
    dispatch(getMyServicemenProfile(userId));
  }, [dispatch, userId]);

  // Load data into form when profile arrives
  useEffect(() => {
    if (myProfile) {
      setForm({
        fullName: myProfile.user?.name || "",
        phone: myProfile.contactNumber || "",
        serviceName: myProfile.serviceName || "",
        experience: myProfile.workExperience || "",
        address: myProfile.address || "",
      });
    }
  }, [myProfile]);

  // SweetAlert Messages
  useEffect(() => {
    if (successMessage) {
      Swal.fire("Success", successMessage, "success");
      dispatch(clearServicemenMessages());
      setEditMode(false);
    }
    if (errorMessage) {
      Swal.fire("Error", errorMessage, "error");
      dispatch(clearServicemenMessages());
    }
  }, [successMessage, errorMessage, dispatch]);

  // Submit Update
  const handleSubmit = () => {
    const formData = new FormData();
    Object.keys(form).forEach((key) => formData.append(key, form[key]));

    dispatch(updateServicemen({ id: myProfile._id, formData }));
  };

  if (loading || !myProfile) return <p className="text-center mt-4">Loading...</p>;

  return (

    <div className="container mt-4">

      <h3 className="mb-4">My Servicemen Profile</h3>

      <div className="card shadow-lg border-0">
        <div className="row g-0">

          {/* LEFT SIDE PROFILE IMAGE */}
          <div className="col-md-4 text-center bg-light p-4">
            <img
              src={myProfile.profileImage}
              alt="Profile"
              className="img-fluid rounded"
              style={{ height: "230px", objectFit: "cover" }}
            />
            <h4 className="mt-3">{myProfile.fullName}</h4>
            <span className={`badge ${myProfile.isVerified ? "bg-success" : "bg-warning text-dark"}`}>
              {myProfile.isVerified ? "Verified" : "Pending Verification"}
            </span>
            <hr />

            <span>
              {myProfile.about}
            </span>

          </div>

          {/* RIGHT SIDE DETAILS */}
          <div className="col-md-8 p-4">

            {!editMode ? (
              <>

                <h5 className="mb-3">Profile Details</h5>

                <table className="table table-bordered">
                  <tbody>
                    <tr>
                      <th>Aadhar Image</th>
                      <td>
                        <img
                          src={myProfile.aadharImage}
                          alt="Profile"
                          className="img-fluid rounded"
                          style={{ height: "230px", objectFit: "cover" }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>Aadhar Number</th>
                      <td>{myProfile.aadharNumber}</td>
                    </tr>
                    <tr>
                      <th>Full Name</th>
                      <td>{myProfile.user?.name}</td>
                    </tr>
                    <tr>
                      <th>Email</th>
                      <td>{myProfile.user?.email}</td>
                    </tr>
                    <tr>
                      <th>Personal Number</th>
                      <td>{myProfile.user?.phoneNumber}</td>
                    </tr>

                    <tr>
                      <th>Contact Number</th>
                      <td>{myProfile.contactNumber}</td>
                    </tr>

                    <tr>
                      <th>Service</th>
                      <td>{myProfile.category?.name}</td>
                    </tr>
                    <tr>
                      <th>Experience</th>
                      <td>{myProfile.workExperience} Years</td>
                    </tr>
                    <tr>
                      <th>Location</th>
                      <td>{myProfile.city}, {myProfile.state}, {myProfile.address}</td>
                    </tr>
                  </tbody>
                </table>

              </>
            ) : (
              <>
                <h5 className="mb-3">Edit Profile</h5>

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Full Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={form.fullName}
                      onChange={(e) => setForm({ ...form, fullName: e.target.value })}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Phone</label>
                    <input
                      type="text"
                      className="form-control"
                      value={form.phone}
                      onChange={(e) => setForm({ ...form, phone: e.target.value })}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Service Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={form.serviceName}
                      onChange={(e) => setForm({ ...form, serviceName: e.target.value })}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Experience (Years)</label>
                    <input
                      type="number"
                      className="form-control"
                      value={form.experience}
                      onChange={(e) => setForm({ ...form, experience: e.target.value })}
                    />
                  </div>

                  <div className="col-12 mb-3">
                    <label className="form-label">Address</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={form.address}
                      onChange={(e) => setForm({ ...form, address: e.target.value })}
                    ></textarea>
                  </div>

                  <div className="d-flex gap-2 mt-3">
                    <button className="btn btn-success" onClick={handleSubmit}>
                      Save Changes
                    </button>
                    <button className="btn btn-secondary" onClick={() => setEditMode(false)}>
                      Cancel
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <ServicemenReviews servicemenId={myProfile._id} />



    </div>
  );
};

export default ServicemenProfile;
